import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { useSecurityVestingQuery } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetails/components/HoldingTable/useSecurityVestingQuery';
import { Flex } from '@mantine/core';
import { VestingExpandedContent } from '@dealstack/frontend/shared/components/VestingChart/VestingExpandedContent.tsx';

export const HoldingVestingDetail = ({
	investorId,
	securityId,
}: {
	investorId: string | undefined;
	securityId: string;
}) => {
	const tMipManage = useTranslationMipManage();
	const vestingQuery = useSecurityVestingQuery(investorId, securityId, true);

	return (
		<Flex direction="column" w="100%" p="1rem">
			<VestingExpandedContent
				vestingQuery={vestingQuery}
				tFunction={tMipManage}
				tooltipTranslationKey="investors.details.holdings_table.chart.tooltip"
				xLabel={tMipManage('investors.details.holdings_table.chart.x_label')}
				yLabel={tMipManage('investors.details.holdings_table.chart.y_label')}
			/>
		</Flex>
	);
};
